



const SkillSelect = ({select}) => {
    return (
        <select defaultValue={select}>
            <option value="all">All Skills</option>
            <option value="drawing">Drawing</option>
            <option value="painting">Painting</option>
            <option value="sketching">Sketching</option>
            <option value="crafting">Crafting</option>
            <option value="calligraphy">Calligraphy</option>
            <option value="digital-art">Digital Art</option>

            {/* Music & Performance */}
            <option value="vocal">Vocal Singing</option>
            <option value="guitar">Guitar</option>
            <option value="piano">Piano</option>
            <option value="dance">Dance</option>
        </select>
    );
}
 
export default SkillSelect;